__webpack_require__.p = "/core/assets/spa2/";